<template>
	<div class="mg-b-20 mg-lg-b-25 mg-xl-b-30">
		<div v-if="loading">
			<spinner-component :loading="loading"/>
		</div>

		<div v-if="error" class="tx-center tx-danger">
			{{ error }}
		</div>

		<div v-else>
			<div v-if="!portfolio && !loading" class="row">
				<div class="col-12">
					<h5 class="tx-color-01 mg-b-5 tx-center">No Portfolios available.</h5>
					<p class="tx-color-03 tx-13 tx-center">Click on the "Set New Goal" to create one.</p>

					<div class="mg-t-20 tx-center">
						<router-link class="btn btn-default wd-lg-200 mx-auto shadow-sm" :to="{ name: 'set-new-goal'}">Set New Goal</router-link>
					</div>
				</div>
			</div>
			<div v-if="portfolio" class="row">
				<div class="col-12 mb-4">
					<div class="accordion" id="overallChart">
						<div class="card shadow-sm overall-chart">
							<div class="card-header bd-b-0 pb-0">
                                <div class="d-md-flex align-items-center justify-content-between">
                                    <div>
                                        <h6 class="mg-b-5">
                                            <button class="btn btn-link" type="button" data-toggle="collapse" data-target="#collapseOverallChart" aria-expanded="true" aria-controls="collapseOverallChart">
                                                Overall
                                            </button>

                                            <div v-if="isMobile" class="dropdown dropright d-inline float-right">
                                                <button class="btn btn-sm btn-white shadow-sm dropdown-toggle" type="button" id="droprightMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                    Options
                                                </button>
                                                <div class="dropdown-menu" aria-labelledby="droprightMenuButton">
                                                    <router-link class="dropdown-item" :to="{ name: 'requests.deposit' }">Add Funds</router-link>
                                                    <router-link class="dropdown-item" :to="{ name: 'requests.withdraw' }">Withdraw</router-link>
													<a :href="`/statements/${company.external_client_id}/generate-pdf`" class="dropdown-item" target="_blank"><i data-feather="download" class="wd-10 mg-r-5"></i> Statement</a>
                                                </div>
                                            </div>
                                        </h6>
                                        <p class="tx-13 tx-color-03 mg-b-0"></p>
                                    </div>
                                    <div v-if="!isMobile" class="d-flex flex-column flex-sm-row mg-t-20 mg-md-t-0">
                                        <router-link class="btn btn-default pd-x-15 mg-l-5 shadow-sm" :to="{ name: 'requests.deposit' }">Add Funds</router-link>
                                        <router-link class="btn btn-primary pd-x-15 mg-l-5 shadow-sm" :to="{ name: 'requests.withdraw' }">Withdraw</router-link>
										<a :href="`/statements/${company.external_client_id}/generate-pdf`" class="btn btn-white pd-x-15 mg-l-5 shadow-sm" target="_blank"><i data-feather="download" class="wd-10 mg-r-5"></i> Statement</a>
                                    </div>
                                </div>
							</div>
							<div id="collapseOverallChart" class="collapse show" data-parent="#overallChart">
								<div class="card-footer bd-t-0 p-0" :class="{ 'mt-5': !isMobile }">
									<overall-chart-component :portfolio-allocation="portfolio.allocation"/>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div v-for="portfolio in portfolio.data" :key="portfolio.id" class="col-xl-3 col-lg-6 col-md-6 mb-4">
					<portfolio-card-component :portfolio="portfolio"/>
				</div>
			</div>
		</div>
		<div v-if="!loading && !error" class="row d-none">
			<div class="col-12 text-center">
				<router-link class="btn btn-default wd-lg-200 mx-auto shadow-sm" :to="{ name: 'requests.deposit' }">Add Funds</router-link>
			</div>
		</div>
	</div>
</template>

<style scoped>
.card.overall-chart .card-footer {
	min-height: 200px;
}

@media (max-width: 450px) {
	.card.overall-chart .card-footer {
		min-height: 240px;
	}
}

@media (max-width: 768px) {
	.row.justify-content-center {
		-webkit-box-pack: start !important;
		justify-content: start !important;
	}
}

.card-body {
	padding: 25px;
}

.set-new-goal {
	vertical-align: middle;
	align-items: center;
	border: none;
	font-size: 17.5px;
	color: #f4911e !important;
	transition: all 0.2s ease-in-out;
}

.set-new-goal:hover {
	transform: scale(1.1);
}
</style>

<script>
import plus from '../../../../img/plus.svg';
import { mapActions, mapGetters } from 'vuex';

export default {
	mounted() {
		this.setCashBalance(this.$store.getters.company.external_client_id);
		this.setAccountShareBalance(this.$store.getters.company.external_client_id);
	},
	data() {
		return {
			plus,
			loading: false,
			portfolio: null,
			error: null,
		};
	},
	created() {
		this.fetchPortfolio();
	},
	computed: {
		...mapGetters({
			company: 'company',
		}),
		hasPortfolio() {
			if (this.portfolio) {
				return !_.isEmpty(this.portfolio.data);
			}
		},
	},
	updated() {
		feather.replace();
	},
	methods: {
		...mapActions({
			setCashBalance: 'trade/setCashBalance',
			setAccountShareBalance: 'trade/setAccountShareBalance',
		}),
		fetchPortfolio() {
			this.error = this.portfolio = null;
			this.loading = true;

			axios
				.get(`/api/companies/${this.company.external_client_id}/portfolios`)
				.then((response) => {
					this.portfolio = response.data.data.portfolio;
				})
				.catch((error) => {
					this.error = error.toString();
				})
				.finally(() => {
					this.loading = false;
				});
		},
	},
};
</script>
